import { useState } from "react";
import { useParams, Link } from "react-router-dom";
import { toast } from "sonner";
import { Loader2, Send } from "lucide-react";
import { api, apiError } from "@/lib/api";
import { useI18n } from "@/i18n";

export default function ReviewSubmit() {
  const { token } = useParams();
  const { t } = useI18n();
  const [form, setForm] = useState({ author: "", location: "", rating: 5, text: "" });
  const [busy, setBusy] = useState(false);
  const [sent, setSent] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      await api.post("/reviews/submit", { token, ...form, rating: Number(form.rating) });
      setSent(true);
    } catch (err) {
      toast.error(apiError(err.response?.data?.detail));
    } finally {
      setBusy(false);
    }
  };

  if (sent)
    return (
      <div className="mx-auto max-w-xl px-6 py-32 text-center" data-testid="review-sent">
        <h1 className="display-xl text-4xl text-bone">{t("revf.thanks")}</h1>
        <p className="mt-6 text-sm leading-loose text-bone/72">{t("revf.thanksText")}</p>
        <Link to="/" className="btn-primary mt-10">{t("revf.home")}</Link>
      </div>
    );

  return (
    <div className="mx-auto max-w-2xl px-6 py-20" data-testid="review-form-page">
      <p className="eyebrow">{t("revf.eyebrow")}</p>
      <h1 className="display-xl mt-6 text-5xl text-bone sm:text-6xl">{t("revf.title")}</h1>
      <p className="mt-6 text-sm leading-loose text-bone/72">{t("revf.intro")}</p>
      <form onSubmit={submit} className="panel mt-10 space-y-5 p-8">
        <label className="block text-sm">
          <span className="mb-2 block text-bone">{t("revf.author")}</span>
          <input required className="field" data-testid="rev-author" value={form.author}
            onChange={(e) => setForm({ ...form, author: e.target.value })} />
        </label>
        <label className="block text-sm">
          <span className="mb-2 block text-bone">{t("revf.city")}</span>
          <input className="field" data-testid="rev-location" value={form.location}
            onChange={(e) => setForm({ ...form, location: e.target.value })} />
        </label>
        <label className="block text-sm">
          <span className="mb-2 block text-bone">{t("revf.rating")}</span>
          <select className="field" data-testid="rev-rating" value={form.rating}
            onChange={(e) => setForm({ ...form, rating: e.target.value })}>
            {[5, 4, 3, 2, 1].map((n) => <option key={n} value={n}>{n} {n > 1 ? t("revf.stars") : t("revf.star")}</option>)}
          </select>
        </label>
        <label className="block text-sm">
          <span className="mb-2 block text-bone">{t("revf.text")}</span>
          <textarea required rows={6} className="field" data-testid="rev-text" value={form.text}
            onChange={(e) => setForm({ ...form, text: e.target.value })} />
        </label>
        <button className="btn-primary w-full" disabled={busy} data-testid="rev-submit">
          {busy ? <Loader2 size={15} className="animate-spin" /> : <Send size={15} />} {t("revf.submit")}
        </button>
      </form>
    </div>
  );
}
